"use client";

import React, { useEffect, useState } from "react";
import Modal from "../common/Modal";
import ProductShowcase from "./ProductShowcase";
import { ProductDetail, Product } from "@/packages/types/products";
import { fetchProductDetailBySlug } from "@/api-service/product";
import { toast } from "sonner";

interface QuickViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  slug?: string;
  onAddedToCart?: (product: Product) => void;
}

const QuickViewModal: React.FC<QuickViewModalProps> = ({
  isOpen,
  onClose,
  slug,
  onAddedToCart,
}) => {
  const [product, setProduct] = useState<ProductDetail>();

  useEffect(() => {
    if (!slug) return;
    const fetchData = async () => {
      try {
        const products = await fetchProductDetailBySlug(slug);
        setProduct(products.data);
      } catch (error: unknown) {
        console.error("Error fetching products:", error);
        type ApiErr = { data?: { data?: { message?: string } } };
        const msg =
          (error as ApiErr).data?.data?.message ||
          (error instanceof Error ? error.message : "Something went wrong");
        toast.error(msg);
      }
    };
    fetchData();
  }, [slug]);

  const handleAddedToCart = (prod: Product) => {
    if (onAddedToCart) onAddedToCart(prod);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {slug && product ? (
        <ProductShowcase
          product={product}
          onAddedToCart={handleAddedToCart}
          autoplay={false}
        />
      ) : (
        <div className="p-6 text-center">Loading...</div>
      )}
    </Modal>
  );
};

export default QuickViewModal;
